import SectionHeading from '../shared/SectionHeading'
import styles from './styles.module.scss'

const ProblemSection = (): JSX.Element => (
  <section className={`${styles.block} ${styles.problem}`}>
    <div className={`${styles.content} ${styles.center}`}>
      <SectionHeading
        eyebrow="なぜ、いま募集しているのか"
        title="“荷物に困る人”を、なくしたい"
        description="旅行・観光・イベント。荷物の置き場所がないだけで、その日の自由が奪われています。"
      />
      <div className={styles.problemGrid}>
        <div className={`${styles.problemCard} ${styles.reveal}`} data-reveal="">
          <img src="/partner-introduction/locker_problem_icon.svg" alt="コインロッカーが満杯" />
          <h3>コインロッカーが空いていない</h3>
          <p>旅行先で空きが見つからず、スーツケースを持ったまま観光するしかない。</p>
        </div>
        <div className={`${styles.problemCard} ${styles.reveal}`} data-reveal="">
          <img
            src="/partner-introduction/event_problem_icon.svg"
            alt="ライブ・イベントのチケット"
          />
          <h3>ライブ・イベント前に預けたい</h3>
          <p>大きな荷物を持ったまま会場へ。預ける場所が会場周辺に足りない。</p>
        </div>
        <div className={`${styles.problemCard} ${styles.reveal}`} data-reveal="">
          <img src="/partner-introduction/map_problem_icon.svg" alt="地図とピン" />
          <h3>まだ足りないエリアがある</h3>
          <p>主要駅や空港の周辺でも、預けられる場所を必要としている人がいます。</p>
        </div>
      </div>
    </div>
  </section>
)

export default ProblemSection
